import { Component } from '@angular/core';

@Component({
  selector: 'ln-shopping-cart-product-deleted',
  imports: [],
  templateUrl: './shopping-cart-product-deleted.component.html',
  styleUrl: './shopping-cart-product-deleted.component.css',
})
export class ShoppingCartProductDeletedComponent {}
